import { FC, useLayoutEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';
import { Action } from 'history';

const ScrollToTop: FC = () => {
  const location = useLocation();
  const navigationType = useNavigationType();

  useLayoutEffect(() => {
    if (navigationType !== Action.Pop) {
      window.scrollTo(0, 0);
    }
  }, [location, navigationType]);

  return null;
};

export default ScrollToTop;
